<template>
	<b-modal
		visible
		:size="size"
		:title="title"
		:centered="centered"
		hide-footer
		no-close-on-backdrop
		:no-close-on-esc="!closeOnEscape || !closable"
		@ok="$emit('ok')"
		@hidden="$emit('hidden')"
	>
		<template #modal-header>
			<h4 class="modal-title">
				<span>{{ title }}</span>
				<a v-if="!hideClose && closable" href="#" @click.prevent="onClose">
					<Icon icon="close"/>
				</a>
			</h4>
			<div v-if="subTitle" class="modal-sub-title">{{ subTitle }}</div>
		</template>
		<slot/>
		<div v-if="!hideActions" class="actions">
			<div v-if="!hideCancel && closable" :class="{ 'mt-2 mt-md-0 mr-md-4': !hideOk }">
				<a href="#" @click.prevent="$emit('hidden')">{{ cancelText }}</a>
			</div>
			<div v-if="!hideOk">
				<Button
					:text="okText"
					:disabled="okDisabled"
					:loading="okLoading"
					:icon="okIcon"
					@click="$emit('ok')"
				/>
			</div>
		</div>
	</b-modal>
</template>

<script>
import Button from "@/vue/common/Button"
import Icon from "@/vue/icon/Icon"

export default {

	components: {
		Button,
		Icon,
	},

	props: {
		title: {
			type: String,
			required: true,
		},
		subTitle: {
			type: String,
			required: false,
		},
		okText: {
			type: String,
			required: false,
		},
		okIcon: {
			type: String,
			required: false,
			default: 'checkmark'
		},
		okDisabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		okLoading: {
			type: Boolean,
			required: false,
			default: false,
		},
		cancelText: {
			type: String,
			required: false,
			default: 'Abbrechen',
		},
		hideActions: {
			type: Boolean,
			required: false,
			default: false,
		},
		hideCancel: {
			type: Boolean,
			required: false,
			default: false,
		},
		hideOk: {
			type: Boolean,
			required: false,
			default: false,
		},
		hideClose: {
			type: Boolean,
			required: false,
			default: false,
		},
		size: {
			type: String,
			required: false,
			default: 'md',
		},
		centered: {
			type: Boolean,
			required: false,
			default: true,
		},
		closeOnEscape: {
			type: Boolean,
			required: false,
			default: true,
		},
		closable: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	methods: {
		onClose ()
		{
			this.$emit('hidden', {userClick: true});
		}
	}
}
</script>
